
    import { mdiGithub, mdiHeart, mdiVuejs } from '@mdi/js';
    import { Component, Vue } from 'vue-property-decorator';
    import {
        VBtn,
        VFlex,
        VFooter,
        VIcon,
        VLayout,
    } from 'vuetify/lib';

    @Component({
        components: {
            VBtn,
            VFlex,
            VFooter,
            VIcon,
            VLayout,
        },
    })

    export default class Footer extends Vue {
        iconMdiGithub = mdiGithub;

        iconMdiHeart = mdiHeart;

        iconMdiVuejs = mdiVuejs;
    }
